<label class="visually-hidden" for="autoSizingInput">User</label>
<util-progress *ngIf="loading" [bar]="true"></util-progress>
<ng-select
        id="autoSizingInput"
        [items]="users"
        [hideSelected]="true"
        [multiple]="false"
        [addTag]="true"
        (keyup)="searchUsersForEvent($event)"
        bindLabel="label"
        bindValue="username"
        [(ngModel)]="username"
        (change)="onUserSelected($event)"
        [ngModelOptions]="{standalone: true}"
        placeholder="User">
</ng-select>
